//* Определяем и экспортируем функцию pagination, которая принимает параметр swiper.
export default function pagination(swiper) {
	// Если swiper не был передан или равен null, выходим из функции (не продолжаем выполнение кода).
	if (!swiper) return;

	// Получаем DOM-элемент с id 'myCanvas' и сохраняем его в переменную canvas.
	const canvas = document.getElementById('myCanvas');
	// Получаем все элементы с классом '.ctx' и сохраняем их в переменную anchorLinks.
	const anchorLinks = document.querySelectorAll('.ctx');
	// Получаем контекст рисования 2D на канвасе (canvas).
	const ctx = canvas.getContext('2d');

	//* Получаем значение CSS-переменных  для цвета линии канваса.
	const convasLineColor = getComputedStyle(document.documentElement).getPropertyValue('--convas-line-color');
	const anchorColor = getComputedStyle(document.documentElement).getPropertyValue('--anchor-color');
	const waveAlphaColor = getComputedStyle(document.documentElement).getPropertyValue('--wave-alpha-color');
	const canvasHeight = getComputedStyle(document.documentElement).getPropertyValue('--canvasHeight');

	//* Для каждого элемента в anchorLinks устанавливаем его цвет в значение anchorColor.
	anchorLinks.forEach(anchorLink => {
		anchorLink.style.color = anchorColor;
	});

	// Устанавливаем ширину канваса равной ширине окна браузера. 
	canvas.width = window.innerWidth;
	// Устанавливаем высоту канваса равной 100px.
	canvas.height = canvasHeight;

	// Устанавливаем базовую амплитуду волны (высоту колебаний). 
	let baseAmplitude = 10;
	// Устанавливаем частоту волны (сколько раз за единицу длины происходит её колебание). 
	let frequency = 0.01;
	// Инициализируем переменную времени для анимации. 
	let time = 0;
	// Получаем количество точек (элементов с классом .ctx), которое равно количеству ссылок.
	let numberOfPoints = anchorLinks.length;
	// Вычисляем расстояние между точками на канвасе.
	let distanceBetweenPoints = canvas.width / (numberOfPoints + 1);
	// Инициализируем индекс целевой точки (каретки). 
	let targetIndex = 0;
	// Вычисляем начальное значение координаты X для каретки (цели). 
	let targetX = (targetIndex + 1) * distanceBetweenPoints;
	// Инициализируем текущую позицию X каретки.
	let currentX = targetX;
	// Массив для хранения волн, создаваемых при кликах. 
	let waves = [];
	// Счётчик количества повторов волн.
	let waveRepeatCount = 0;

	//* Функция для обновления позиции каретки.
	window.updateCaretPosition = function (index) {
		// Обновляем целевой индекс (+ 1, чтобы индекс начинался с 1, а не с 0).
		targetIndex = index + 1;
		// Пересчитываем X-координату целевой точки.
		targetX = targetIndex * distanceBetweenPoints;

		// Добавляем новую волну в массив waves с текущими координатами X и Y, радиусом и альфа-прозрачностью.
		waves.push({ x: targetX, y: getWaveY(targetX), radius: 0, alpha: 1 });
		// Сбрасываем счётчик повторений волн.
		waveRepeatCount = 0;
	};

	//* Добавляем обработчик события на изменение размера окна (resize).
	window.addEventListener('resize', () => {
		// Пересчитываем ширину канваса при изменении размера окна.
		canvas.width = window.innerWidth;
		// Пересчитываем расстояние между точками. 
		distanceBetweenPoints = canvas.width / (numberOfPoints + 1);
		// Пересчитываем X-координату целевой точки после изменения размера.
		targetX = (targetIndex + 1) * distanceBetweenPoints;
		// Обновляем текущую позицию каретки.
		currentX = targetX;
	});

	//* Функция для вычисления вертикальной координаты волны по оси Y на основе X.
	function getWaveY(x) {
		// Возвращаем значение Y, которое зависит от синусоиды, частоты, амплитуды и времени.
		return canvas.height / 2 + Math.sin(x * frequency) * baseAmplitude * Math.sin(time);
	}

	//* Функция для рисования точки на канвасе по координатам (x, y).
	function drawPoint(x, y) {
		// Начинаем новый путь (рисование). 
		ctx.beginPath();
		// Рисуем окружность радиусом 3 с центром в точке (x, y). 
		ctx.arc(x, y, 3, 0, Math.PI * 2);
		// Устанавливаем цвет заливки для точки. 
		ctx.fillStyle = anchorColor;
		// Закрашиваем точку.
		ctx.fill();
	}

	//* Функция для рисования кривой каретки.
	function drawCurvedCaret(x) {
		// Задаём длину каретки.
		const caretLength = 80;
		// Количество сегментов кривой.
		const segments = 10;
		// Вычисляем длину каждого сегмента.
		const segmentLength = caretLength / segments;
		// Начинаем новый путь для рисования каретки.
		ctx.beginPath();

		// Проходим по всем сегментам каретки.
		for (let i = -segments / 2; i <= segments / 2; i++) {
			// Вычисляем X-координату текущего сегмента. 
			let xi = x + i * segmentLength;
			// Вычисляем Y-координату для текущего X с использованием функции getWaveY.
			let yi = getWaveY(xi);

			if (i === -segments / 2) {
				// Если это первый сегмент, перемещаем перо к начальной точке.
				ctx.moveTo(xi, yi);
			} else {
				// Если это не первый сегмент, рисуем линию к следующей точке.
				ctx.lineTo(xi, yi);
			}
		}

		// Устанавливаем цвет линии каретки. 
		ctx.strokeStyle = anchorColor;
		// Устанавливаем толщину линии каретки.
		ctx.lineWidth = 2;
		// Рисуем линию.
		ctx.stroke();
	}

	//* Функция для рисования волн.
	function drawWaves() {
		// Проходим по массиву волн в обратном порядке.
		for (let i = waves.length - 1; i >= 0; i--) {
			// Получаем текущую волну.
			let wave = waves[i];

			//* Начинаем рисование волны
			// Начинаем новый путь для рисования волны
			ctx.beginPath();
			// Рисуем окружность для волны
			ctx.arc(wave.x, wave.y, wave.radius, 0, Math.PI * 2);
			// Устанавливаем цвет линии волны с учётом прозрачности
			ctx.strokeStyle = waveAlphaColor;
			// Устанавливаем толщину линии волны
			ctx.lineWidth = 1;
			// Рисуем волну
			ctx.stroke();

			//* Влияние времени на радиус волны для замедления её распространения
			// Увеличиваем время, создавая эффект замедления
			wave.time += 0.2;
			// Увеличиваем радиус волны с учетом времени (3 - это множитель скорости)
			wave.radius = wave.time * 3;
			// Уменьшаем прозрачность волны.
			wave.alpha -= 0.014;

			// Если прозрачность волны стала равной 0, удаляем её из массива.
			if (wave.alpha <= 0) {
				waves.splice(i, 1);

				// Проверяем, повторялась ли волна дважды
				if (waveRepeatCount < 2) {
					// Если волна повторяется менее 2 раз, добавляем её обратно в массив
					waves.push({ x: wave.x, y: wave.y, radius: 0, alpha: 1, time: 0 }); // Обнуляем время
					// Увеличиваем счётчик повторений волн
					waveRepeatCount++;
				}
			}
		}
	}


	//* Функция для обновления позиции каретки.
	window.updateCaretPosition = function (index) {
		targetIndex = index + 1;
		targetX = targetIndex * distanceBetweenPoints;

		// Добавляем две волны в массив с текущими координатами X и Y.
		waves.push({ x: targetX, y: getWaveY(targetX), radius: 0, alpha: 1, time: 0 });
		waves.push({ x: targetX, y: getWaveY(targetX), radius: 0, alpha: 1, time: 0 });
		// Сбрасываем счётчик повторений волн.
		waveRepeatCount = 0;
	};


	//* Функция для анимации.
	function animate() {
		// Очищаем канвас перед рисованием нового кадра.
		ctx.clearRect(0, 0, canvas.width, canvas.height);
		// Вычисляем амплитуду волны в зависимости от времени.
		let amplitude = baseAmplitude * Math.sin(time);
		// Начинаем рисование основной волны.
		ctx.beginPath();
		// Перемещаем перо в начальную точку (левый край канваса).
		ctx.moveTo(0, canvas.height / 2);

		// Проходим по всем точкам по оси X на канвасе с шагом 5px.
		for (let i = 0; i < canvas.width; i += 5) {
			// Вычисляем координату Y для каждой точки на волне.
			let y = canvas.height / 2 + Math.sin(i * frequency) * amplitude;
			// Рисуем линию от предыдущей точки к текущей.
			ctx.lineTo(i, y);
		}
		// Устанавливаем цвет для основной линии волны. 
		ctx.strokeStyle = convasLineColor;
		// Устанавливаем толщину линии для основной волны. 
		ctx.lineWidth = 2;
		// Рисуем линию.
		ctx.stroke();

		// Проходим по всем точкам на волне.
		for (let i = 0; i < numberOfPoints; i++) {
			// Вычисляем X-координату для точки.
			let x = (i + 1) * distanceBetweenPoints;
			// Вычисляем Y-координату для точки. 
			let y = getWaveY(x);
			// Рисуем точку на канвасе.
			drawPoint(x, y);
			// Находим элемент с классом '.ctx' и соответствующим индексом.
			const cityElement = document.querySelector(`.ctx[data-index="${i}"]`);

			if (cityElement) {
				// Устанавливаем положение элемента в горизонтальной оси.
				cityElement.style.left = `${x - cityElement.offsetWidth / 2}px`;
			}
		}
		// Рисуем все волны.
		drawWaves();

		// Двигаем каретку в сторону её целевой позиции. 
		currentX += (targetX - currentX) * 0.05;
		// Рисуем каретку. 
		drawCurvedCaret(currentX);
		// Увеличиваем время для анимации. 
		time += 0.005;
		// Запрашиваем следующий кадр анимации.
		requestAnimationFrame(animate);
	}
	// Запускаем анимацию.
	animate();

	// Для каждого элемента в anchorLinks добавляем обработчик события клика.
	anchorLinks.forEach((link, index) => {
		// При клике на точку выполняется следующая функция.
		link.addEventListener('click', (event) => {
			// Предотвращаем стандартное поведение ссылки.
			event.preventDefault();
			// Обновляем позицию каретки.
			window.updateCaretPosition(index);

			// Если swiper передан, переключаем слайд на соответствующий индекс.
			if (swiper) {
				swiper.slideToLoop(index);
			} else {
				// Если swiper не передан, выводим ошибку.
				console.error('Swiper не найден');
			}
		});
	});
}